export default __webpack_public_path__ + "static/SR India - Kosher - Certificate-3b2625e120630771e0e1fe658045a41c.pdf";